/**
 * 当期选号/筹码回显：按期号写入 sessionStorage，离开再进可恢复；换期清空。
 */
export function usePeriodPickPersist (storageKey) {
  const read = () => {
    try {
      const raw = JSON.parse(sessionStorage.getItem(storageKey) || 'null')
      return raw && typeof raw === 'object' ? raw : null
    } catch (_) {
      return null
    }
  }

  const write = (data) => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(data))
    } catch (_) { /* ignore */ }
  }

  const clear = () => {
    try {
      sessionStorage.removeItem(storageKey)
    } catch (_) { /* ignore */ }
  }

  /** 期号一致则 apply(data)，否则清掉过期缓存 */
  const restoreIfSamePeriod = (numero, apply) => {
    const data = read()
    if (!data) return false
    const cur = String(numero || '')
    if (!cur || String(data.numero || '') !== cur) {
      clear()
      return false
    }
    apply(data)
    return true
  }

  /** 缓存期号与当前不一致时清空选号缓存 */
  const clearIfPeriodChanged = (numero) => {
    const data = read()
    if (!data?.numero || !numero) return false
    if (String(data.numero) === String(numero)) return false
    clear()
    return true
  }

  return { read, write, clear, restoreIfSamePeriod, clearIfPeriodChanged }
}
